import styled from 'styled-components';

export const ToggleInput = styled.input`
  position: absolute;
  height: 0;
  width: 0;
  visibility: hidden;
`;

export const ToggleLabel = styled.label<{
  $checked?: boolean;
  $round?: boolean;
  $size?: string;
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: ${({ $round }) =>
    $round &&
    '0 0.3rem 0.8rem  rgba(0, 0, 0, 0.15), 0 0.3rem 0.1rem rgba(0, 0, 0, 0.06)'};
  cursor: pointer;
  width: ${({ $round, $size }) => ($round ? $size || '3rem' : '5rem')};
  height: ${({ $size }) => $size || '3rem'};
  background: ${({ $checked, theme }) =>
    $checked ? theme.color.primary : 'rgba(120, 120, 128, 0.20)'};
  border-radius: ${({ theme }) => theme.borderRadius.radius100};
  transition: background-color 0.25s;
`;

export const ToggleSwitcher = styled.span<{
  $checked: boolean;
  $size?: string;
}>`
  content: '';
  position: absolute;
  top: 0.2rem;
  width: ${({ $size }) => $size ?? '2.6rem'};
  height: ${({ $size }) => $size ?? '2.6rem'};
  border-radius: 4.5rem;
  transition: 0.25s;
  background: ${({ theme }) => theme.color.white};
  box-shadow:
    0 0.3rem 0.8rem rgba(0, 0, 0, 0.15),
    0 0.3rem 0.1rem rgba(0, 0, 0, 0.06);
  left: ${({ $checked }) => ($checked ? 'calc(100% - 0.2rem)' : '0.2rem')};
  transform: ${({ $checked }) => ($checked ? 'translateX(-100%);' : 'none')};
`;
